import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=53cd1a5e&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Faq.vue?vue&type=style&index=1&id=53cd1a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd1a5e",
  null
  
)

export default component.exports